<template>
  <div class="chat-filter-main">
    <v-autocomplete
      v-model="inputText"
      :items="participantNames"
      class="autocomplete px-3 mt-4"
      clearable
      dense
      height="36"
      hide-details
      hide-selected
      label="Search"
      outlined
      return-object
      single-line
    >
      <template v-slot:prepend-inner>
        <v-icon class="pt-1" color="icon" size="20">mdi-magnify</v-icon>
      </template>
    </v-autocomplete>

    <div class="action-container">
      <div class="autocomplete-wrapper">
        <v-text-field v-model="query" class="query-field" dense hide-details placeholder="Start typing to search" solo>
          <template v-slot:prepend-inner>
            <v-icon class="pt-1" color="icon" size="20">mdi-magnify</v-icon>
          </template>
        </v-text-field>
      </div>
      <div class="button-wrapper">
        <button
          class="mx-1 ml-2"
          v-bind:class="{ button: !isAdvancedOpen, 'button-opened': isAdvancedOpen }"
          @click="toggleModal"
        >
          <svg fill="none" height="12" viewBox="0 0 14 12" width="14" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M3.31129 0C3.18412 0 3.06217 0.0483904 2.97225 0.134526C2.88233 0.220662 2.83182 0.337487 2.83182 0.459301V1.15438H2.41788C1.90922 1.15438 1.4214 1.34794 1.06173 1.69248C0.702061 2.03702 0.5 2.50432 0.5 2.99158V10.1628C0.5 10.6501 0.702061 11.1174 1.06173 11.4619C1.4214 11.8064 1.90922 12 2.41788 12H11.5821C12.0908 12 12.5786 11.8064 12.9383 11.4619C13.2979 11.1174 13.5 10.6501 13.5 10.1628V2.99158C13.5 2.50432 13.2979 2.03702 12.9383 1.69248C12.5786 1.34794 12.0908 1.15438 11.5821 1.15438H11.1682V0.459301C11.1682 0.337487 11.1177 0.220662 11.0277 0.134526C10.9378 0.0483904 10.8159 0 10.6887 0C10.5616 0 10.4396 0.0483904 10.3497 0.134526C10.2598 0.220662 10.2092 0.337487 10.2092 0.459301V1.15438H7.47947V0.459301C7.47947 0.337487 7.42895 0.220662 7.33904 0.134526C7.24912 0.0483904 7.12716 0 7 0C6.87284 0 6.75088 0.0483904 6.66096 0.134526C6.57105 0.220662 6.52053 0.337487 6.52053 0.459301V1.15438H3.79076V0.459301C3.79076 0.337487 3.74024 0.220662 3.65032 0.134526C3.5604 0.0483904 3.43845 0 3.31129 0ZM12.5411 10.1628C12.5411 10.4064 12.44 10.6401 12.2602 10.8123C12.0804 10.9846 11.8365 11.0814 11.5821 11.0814H2.41788C2.16355 11.0814 1.91964 10.9846 1.7398 10.8123C1.55997 10.6401 1.45894 10.4064 1.45894 10.1628V5.15029H12.5411V10.1628ZM6.52053 2.07298V2.76805C6.52053 2.88987 6.57105 3.00669 6.66096 3.09283C6.75088 3.17896 6.87284 3.22735 7 3.22735C7.12716 3.22735 7.24912 3.17896 7.33904 3.09283C7.42895 3.00669 7.47947 2.88987 7.47947 2.76805V2.07298H10.2092V2.76805C10.2092 2.88987 10.2598 3.00669 10.3497 3.09283C10.4396 3.17896 10.5616 3.22735 10.6887 3.22735C10.8159 3.22735 10.9378 3.17896 11.0277 3.09283C11.1177 3.00669 11.1682 2.88987 11.1682 2.76805V2.07298H11.5821C11.8365 2.07298 12.0804 2.16976 12.2602 2.34203C12.44 2.5143 12.5411 2.74795 12.5411 2.99158V4.23169H1.45894V2.99158C1.45894 2.74795 1.55997 2.5143 1.7398 2.34203C1.91964 2.16976 2.16355 2.07298 2.41788 2.07298H2.83182V2.76805C2.83182 2.88987 2.88233 3.00669 2.97225 3.09283C3.06217 3.17896 3.18412 3.22735 3.31129 3.22735C3.43845 3.22735 3.5604 3.17896 3.65032 3.09283C3.74024 3.00669 3.79076 2.88987 3.79076 2.76805V2.07298H6.52053Z"
              fill="#2196F3"
            />
          </svg>
        </button>
        <AdvancedSearchModal
          v-model="isAdvancedOpen"
          @close-adv-search-modal="toggleModal"
          @filter-by-date="handleFilterByDate"
        />
      </div>
    </div>
    <v-btn
      v-if="currentStartDate && currentEndDate"
      class="date-filter-container"
      outlined
      rounded
      text
      @click="toggleModal"
    >
      {{ formatDate(currentStartDate) }} to {{ formatDate(currentEndDate) }}
    </v-btn>
  </div>
</template>

<script>
import { mapActions, mapState } from "pinia";

import { useAuthStore } from "@/pinia-store/auth";
import { useChatStore } from "@/pinia-store/chat";

import AdvancedSearchModal from "./AdvancedSearchModal";

export default {
  name: "ChatFilter",
  components: { AdvancedSearchModal },
  props: {
    participants: Array,
  },
  data: function () {
    return {
      inputText: "",
      query: "",
      isFocused: false,
      isAdvancedOpen: false,
      filteringDebounceTimer: null,
      mappingParticipantsTimer: null,
      participantNames: [],
      currentStartDate: null,
      currentEndDate: null,
    };
  },
  mounted() {
    this.mapParticipantNames(this.participants);
  },
  computed: {
    ...mapState(useAuthStore, ["uid"]),
    // todo: fix this

    isPractitioner() {
      return this.$store.getters.userIsPractitioner;
    },
  },
  methods: {
    ...mapActions(useChatStore, [
      "setFilterQuery",
      "setFilterStartDate",
      "setFilterEndDate",
      "setFilterParticipantName",
    ]),
    formatDate(date) {
      return this.$moment(date).format("D MMMM YYYY");
    },
    mapParticipantNames(participants) {
      if (this.mappingParticipantsTimer) clearTimeout(this.mappingParticipantsTimer);
      this.filteringDebounceTimer = setTimeout(() => {
        this.participantNames = participants
          .map((participant) => {
            if (participant?.uid === this.uid) return;
            return participant?.meta?.displayName?.trim() || "";
          })
          .filter((element) => element);
        this.participantNames.push("None");
      }, 700);
    },
    debounceFilter() {
      if (this.filteringDebounceTimer) clearTimeout(this.filteringDebounceTimer);
      this.filteringDebounceTimer = setTimeout(() => {
        this.$emit("filter-channels", {
          participantName: this.inputText?.trim(),
          query: this.query,
          timeSpan: { startDate: this.currentStartDate, endDate: this.currentEndDate },
        });
      }, 500);
    },
    handleFilterByDate(payload) {
      this.currentStartDate = payload.startDate;
      this.currentEndDate = payload.endDate;
      this.debounceFilter();
    },
    toggleModal() {
      this.isAdvancedOpen = !this.isAdvancedOpen;
    },
  },
  destroyed() {
    clearInterval(this.filteringDebounceTimer);
    clearInterval(this.mappingParticipantsTimer);
  },
  watch: {
    participants(newVal) {
      this.mapParticipantNames(newVal);
    },
    inputText(value) {
      this.debounceFilter();
      this.setFilterParticipantName(value?.trim());
    },
    query(value) {
      this.setFilterQuery(value);
      this.debounceFilter();
    },
  },
};
</script>

<style lang="scss" scoped>
.chat-filter-main {
  width: 100%;

  .date-filter-container {
    display: flex;
    justify-content: center;
    align-self: center;
    text-align: center;
    justify-self: center;
    margin: 0 auto 25px;
  }

  .action-container {
    padding: 25px 10px;
    justify-content: stretch;
    flex-basis: 100%;
    display: grid;
    grid-template-columns: auto 36px;
    grid-gap: 16px;
    box-shadow: none;

    :deep .v-input__control {
      height: 36px;
    }

    .button {
      &-wrapper {
        align-self: center;
      }

      margin: 0 !important;
      position: relative;
      align-self: center;
      border-radius: 4px;
      min-width: 100%;
      min-height: 36px;
      box-shadow: 0 1px 4px rgba(0, 0, 0, 0.12);

      &:hover {
        border: 1px solid $primary;
      }

      &-opened {
        @extend .button;
        border: 1px solid $primary;
      }
    }

    :deep .v-input .v-input__slot {
      margin: 0 !important;
    }

    :deep .autocomplete {
      margin: 0;
      padding: 0;
      flex: 0 0 auto;
      min-width: 100% !important;
      box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.12);
      border-radius: 4px;

      .query-field {
        font-size: 15px !important;

        .v-input {
          font-size: 15px;
        }
      }

      &-wrapper {
        fieldset {
          color: $primary !important;
          border: none !important;
        }
      }
    }
  }
}
</style>
